
import request from "@/utils/request";
const index = {
  // 列表
  list(query) {
    return request({
      url: "/activitySelect/list",
      method: "get",
      params: query
    });
  },
  // 新增
  create(data) {
    return request({
      url: "/activitySelect/create",
      method: "post",
      data
    });
  },
  // 编辑
  edit(data) {
    return request({
      url: "/activitySelect/edit",
      method: "post",
      data
    });
  },
  // 详情
  detail(query) {
    return request({
      url: "/activitySelect/detail",
      method: "post",
      params: query
    });
  },
  // 删除
  remove(data) {
    return request({
      url: "/activitySelect/remove",
      method: "post",
      data
    });
  },
  // 状态
  status(data) {
    return request({
      url: "/activitySelect/status",
      method: "post",
      data
    });
  },
  // 排序
  sort(data) {
    return request({
      url: "/activitySelect/sort",
      method: "post",
      data
    });
  },
  // 下拉选
  select(query) {
    return request({
      url: "/activitySelect/select",
      method: "get",
      params: query
    });
  },
};
export default index;
